import * as React from "react";
import Button from "@material-ui/core/Button";
import OpenInNewOutlinedIcon from '@material-ui/icons/OpenInNewOutlined';
import {IPatientPortalLinkButtonProps} from "./patient-portal-link-button.interface";
import {PatientPortalLinkPipe} from "../../../shared/patient-portal-link";

export const PatientPortalLinkButton = (props: IPatientPortalLinkButtonProps) => {
    const link = PatientPortalLinkPipe(props.patient.patient!.patientId);

    return (
        <Button
            id={'patient-information-portal-link'}
            variant="outlined"
            color="primary"
            href={link}
            target={'_blank'}
            rel={'noopener noreferrer'}
            startIcon={<OpenInNewOutlinedIcon/>}
        >
            View in Orpyx Portal
        </Button>
    );
};
